import { render, staticRenderFns } from "./ExtraData.vue?vue&type=template&id=2821c95a&scoped=true"
import script from "./ExtraData.vue?vue&type=script&lang=js"
export * from "./ExtraData.vue?vue&type=script&lang=js"
import style0 from "./ExtraData.vue?vue&type=style&index=0&id=2821c95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2821c95a",
  null
  
)

export default component.exports